<template>
	<div>
		<v-dialog v-model="dialog_comp_tax_rate" no-click-animation persistent scrollable transition="dialog-bottom-transition">
	      <v-card flat>
	      	<v-card-title noshadow nopadding>
        		<v-subheader full-width>GST Rate</v-subheader>
        	</v-card-title>

	        <v-card-text dialog-card-content>
	            <v-layout wrap>
	            	<v-form data-vv-scope="fields" full-width>

			            <v-flex xs12 sm12 md12 form-item @click="openDialogTaxRateList(true)">

			               	<v-text-field  
			               		readonly
			               		value="Custom"
			               		label="Select GST Rate" 
			               		placeholder=" "
			               		append-icon="arrow_drop_down">
			               	</v-text-field>
			               	
			            </v-flex>

			            <v-flex xs12 sm12 md12 form-item>
			               <v-text-field 
			               		label="GST Rate (%)" 
			               		placeholder=" " 
			               		type="number" 
			               		v-model.number="taxRate"
			               		v-validate="'required|decimal:2'" 
		               			data-vv-name="customtaxrate" 
		               			data-vv-as="gst rate" 
		               			:error-messages="errors.collect('fields.customtaxrate')">
			               	</v-text-field>
			            </v-flex>

		            </v-form>
	            </v-layout>

	        </v-card-text>
	        <v-divider></v-divider>
	        <v-card-actions>
	        	<v-spacer></v-spacer>
	          <v-btn color="blue darken-1" flat @click.native="$parent.fn_closeDialog">close</v-btn>
	          <v-btn color="blue darken-1" flat @click.native="fn_checkValidations">Done</v-btn>
	        </v-card-actions>
	      </v-card>
	    </v-dialog>
	</div>
</template>

<script>
export default{
	props:['openDialogTaxRateList'],
	data(){	
		return{
			dialog_comp_tax_rate: false,
			// taxName:"Custom",
			taxRate:null
		}
	},
	methods:{
		openDialogWeb: function () {	
			this.errors.clear('fields');
			// this.fn_getTaxRate();
			this.taxRate = this.$parent.compTaxRate.value;
			this.dialog_comp_tax_rate = true;
		},
		closeDialogWeb: function () {
			this.dialog_comp_tax_rate = false;
		},
		// fn_getTaxRate: function(){
		// 	for(let i=0; i<this.$parent.compTaxRateList.length; i++){
	 //          if(this.$parent.compTaxRateList[i].value == this.$parent.compTaxRate.value){
	 //            this.taxName = this.$parent.compTaxRateList[i].name;
	 //            break;
	 //          }
	 //        }
	 //    },
		fn_checkValidations: function () {
			// let valueObj = {};
			// valueObj.taxRate = this.$parent.fn_getTaxRate() == 'Custom' ? this.taxRate : this.$parent.compTaxRate;
			// let taxRate = this.taxName == 'custom' ? this.taxRate : this.$parent.compTaxRate.value;

			this.$validator.validateAll('fields').then((result) => {
				if(result){
					if(this.taxRate)
						this.$parent.fn_updateTaxRate(this.taxRate, 2);
					else
						this.showToast('Please add tax rate');
				}
		    });

			// let self = this;

			// let customError = false;

			// if(!this.$parent.Form.addressData.isBillingAddress && !this.$parent.Form.addressData.isShippingAddress){
			// 	customError = true;
			// }

			// this.$validator.validateAll('fields').then((result) => {
			// 	if(result && !customError){
			// 		this.saveAddress(this.$parent.Form.addressData);
			// 	}
			// 	else{
			// 		let cardElement = document.querySelector('.address .v-card__text');
			// 		let errorElement = document.querySelectorAll('.address .v-card__text .error--text')[0];
			// 		cardElement.scrollTop = errorElement.offsetTop - 100;
			// 	}
		 //    });
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/components/newreports/dialogs/dialog_comp_tax_rate.vue